import filter from "@/api/filter";
// 对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
export const config = {
  data() {
      return {
          searchParams: {},
          columns: []
      };
  },
  methods: {
    getColumns() {
      let idx = ''
      let columns1 =  [
        {
          type: 'selection',
          width: 60,
          fixed: "left",
          align: 'center'
        },
        {
          title: "保单号",
          align: "center",
          fixed: "left",
          key: "policyNo",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "批单号",
          align: "center",
          key: "billNo",
          fixed: "left",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "保险公司",
          align: "center",
          key: "companyName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "保险产品",
          align: "center",
          key: "productName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "险种名称",
          align: "center",
          key: "productTypeName",
          minWidth: 280,
          tooltip: true,
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if (params.row.insureTime) {
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "生效日期",
          align: "center",
          key: "effectTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.effectTime) {
              const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "保费",
          align: "center",
          key: "fee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动<Tooltip
              trigger="hover"
              content="content"
              transfer={true}
            >
              <span class="tip-icon">?</span>
              <div slot="content">
                <div>{ params.row.activityName }</div>
                <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
              </div>
            </Tooltip></span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费</span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: "费率",
          align: "center",
          key: "commission",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            if (params.row.commission && params.row.isDeduct!=1) {
              return <span>{params.row.commission}</span>;
            }else{
              return <span>-</span>;
            }
          },
        },
        {
          title: "费用",
          key: "commissionPrice",
          slot: "commissionPrice",
          width: 150,
          align: "center",
        },
        {
          title: "所属业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "出单团队",
          key: "groupName",
          width: 150,
          align: "center",
        },
        {
          title: "出单机构",
          key: "orgName",
          width: 150,
          align: "center",
        },
      ]

      this.columns = columns1
    },
  }
};